import React, { useMemo, useEffect } from 'react'
import { PageWrapper } from 'pages/styled'
import { AutoColumn } from 'components/Column'
import { TYPE, HideSmall } from 'theme'
import TokenTable from 'components/tokens/TokenTable'
import { useAllTokenData, useTokenDatas } from 'state/tokens/hooks'
import { notEmpty } from 'utils'
import { useSavedTokens } from 'state/user/hooks'
import { DarkGreyCard } from 'components/Card'
import TopTokenMovers from 'components/tokens/TopTokenMovers'
import { Trace } from '@uniswap/analytics'

export default function TokensOverview() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const allTokens = useAllTokenData()

  const formattedTokens = useMemo(() => {
    return Object.values(allTokens)
      .map((t) => t.data)
      .filter(notEmpty)
      .filter((t) => t.tvlUSD > 0) // filter out tokens with 0 TVL
      .map((t) => {
        // unwrap name and symbol
        const newT = structuredClone(t)
        if (t.address === process.env.REACT_APP_WRAPPED_ADDRESS) {
          newT.name = newT.name.split('Wrapped ')[1]
          newT.symbol = newT.symbol.substring(1)
        }
        return newT
      })
  }, [allTokens])

  const [savedTokens] = useSavedTokens()
  const watchListTokens = useTokenDatas(savedTokens)

  return (
    <Trace page="tokens-overview-page" shouldLogImpression>
      <PageWrapper>
        <AutoColumn $gap="lg">
          <TYPE.main>Your Watchlist</TYPE.main>
          {savedTokens.length > 0 ? (
            <TokenTable tokenDatas={watchListTokens} />
          ) : (
            <DarkGreyCard>
              <TYPE.main>Saved tokens will appear here</TYPE.main>
            </DarkGreyCard>
          )}
          <HideSmall>
            <DarkGreyCard style={{ paddingTop: '12px' }}>
              <AutoColumn $gap="md">
                <TYPE.mediumHeader fontSize="16px">Top Movers</TYPE.mediumHeader>
                <TopTokenMovers />
              </AutoColumn>
            </DarkGreyCard>
          </HideSmall>
          <TYPE.main>All Tokens</TYPE.main>
          <TokenTable tokenDatas={formattedTokens} />
        </AutoColumn>
      </PageWrapper>
    </Trace>
  )
}
